(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["review-slides-inner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.swiper-carousel-section .mySwiper', {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: '.swiper-carousel-section .swiper-button-next',
      prevEl: '.swiper-carousel-section .swiper-button-prev'
    },
    pagination: {
      el: '.swiper-carousel-section .swiper-pagination',
      clickable: true
    },
    breakpoints: {
      0: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-slides"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.swiper-carousel-section .mySwiper', {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: '.swiper-carousel-section .swiper-button-next',
      prevEl: '.swiper-carousel-section .swiper-button-prev'
    },
    pagination: {
      el: '.swiper-carousel-section .swiper-pagination',
      clickable: true
    },
    breakpoints: {
      0: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.swiper-carousel-section .mySwiper', {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: '.swiper-carousel-section .swiper-button-next',
      prevEl: '.swiper-carousel-section .swiper-button-prev'
    },
    pagination: {
      el: '.swiper-carousel-section .swiper-pagination',
      clickable: true
    },
    breakpoints: {
      0: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
